const Marionette = require('backbone.marionette'),
    authMgr = require('./app/authMgr'),
    LoginLayout = require('appLoginLayout'),
    notify = require('shared/eventHandlers/notify');
require('shared/extensions/stickit');
require('backbone.routefilter');
require('eonasdan-bootstrap-datetimepicker');

const appDef = Marionette.Application.extend({
    ... notify,
    region: '#appRegion',
    onDomChangeTitle: function (title) {
        $(document).attr('title', title);
    }
});
const app = new appDef;
app.on('start', function (self, options) {
    // Two different layout files.
    // All because marionette's default is to insert an extra div on view.show(), which screws over flexbox.
    // And I can't seem to find how to override the mainRegion el properties further down the road,
    // because our illustrious rewrite helpers obfuscated the code so much that the marionette docs don't help much.
    app.authMgr = authMgr;
    app.showView(new LoginLayout(options));
    Backbone.history.start();
    this.listenTo(Backbone.history, 'all', function () {
        // This is to fix dropdowns (Kendo-only, IIRC) from sticking when the back button is clicked.
        $('.select2-drop-mask').click();
        $('.mutiple_drop_container, .select2-drop, .select2-drop-mask').hide();
    });
});

module.exports = app;